import React from 'react'
import ProgressProvider from './ProgressProvider'
import {iProvider} from './types'

const Provider = ({children}: iProvider): React.ReactElement => {
  return (
    <div>
      <ProgressProvider>
          {children}
      </ProgressProvider>
    </div>
  )
}

export default Provider
